{
  "titles": {
    "appointmentDetailsHaveChanged": "Os detalhes do agendamento foram alterados",
    "appointmentScheduled": "Agendamento marcado",
    "appointmentConfirmed": "Agendamento confirmado",
    "appointmentRequested": "Agendamento solicitado",
    "missedAppointment": "Agendamento perdido",
    "recurringAppointmentSeriesCreated": "Série de agendamentos recorrentes criada",
    "truckArrivedAtFacility": "Caminhão chegou à instalação",
    "appointmentIsInProgressAtFacility": "Agendamento em andamento na instalação",
    "appointmentRescheduled": "Agendamento remarcado",
    "appointmentCompleted": "Agendamento concluído",
    "appointmentCancelled": "Agendamento cancelado",
    "appointmentTagged": "Agendamento marcado com etiqueta",
    "assetReadyForPickup": "Ativo pronto para retirada"
  },
  "subjects": {
    "appointmentDetailsHaveChanged": "Os detalhes do agendamento foram alterados",
    "appointmentScheduled": "Agendamento marcado em {orgName} - {warehouseName}",
    "appointmentConfirmed": "Agendamento confirmado em {orgName} - {warehouseName}",
    "appointmentRequested": "Agendamento solicitado em {orgName} - {warehouseName}",
    "missedAppointment": "Agendamento perdido em {orgName} - {warehouseName}",
    "recurringAppointmentSeriesCreated": "Uma série de agendamentos recorrentes foi criada",
    "truckArrivedAtFacility": "Caminhão chegou a {orgName} - {warehouseName}",
    "appointmentIsInProgressAtFacility": "Agendamento em andamento em {orgName} - {warehouseName}",
    "appointmentRescheduled": "Agendamento remarcado em {orgName} - {warehouseName}",
    "appointmentCompleted": "Agendamento concluído em {orgName} - {warehouseName}",
    "appointmentCancelled": "Agendamento cancelado com {orgName} - {warehouseName}",
    "appointmentTagged": "Agendamento marcado como {tagName} - {warehouseName}",
    "assetReadyForPickup": "Pronto para retirada - Contêiner {containerNumber}"
  },
  "subTitles": {
    "appointmentDetailsHaveChanged": "Por favor, verifique o local, data, horário e todos os detalhes abaixo.",
    "appointmentScheduled": "Por favor, verifique o local, data, horário e todos os detalhes abaixo.",
    "appointmentConfirmed": "Por favor, verifique o local, data, horário e todos os detalhes abaixo.",
    "appointmentRequested": "Por favor, aguarde a confirmação do armazém.",
    "missedAppointment": "O transportador não compareceu ao agendamento.",
    "recurringAppointmentSeriesCreated": "Por favor, verifique os detalhes do agendamento recorrente abaixo.",
    "truckArrivedAtFacility": "Verifique o status e os detalhes do agendamento abaixo.",
    "appointmentIsInProgressAtFacility": "Verifique o status e os detalhes do agendamento abaixo.",
    "appointmentRescheduled": "Verifique o status e os detalhes do agendamento abaixo.",
    "appointmentCompleted": "Verifique o status e os detalhes do agendamento abaixo.",
    "appointmentCancelled": "Por favor, verifique todos os detalhes e o motivo do cancelamento.",
    "appointmentTagged": "Por favor, verifique o nome da etiqueta e as informações abaixo.",
    "assetReadyForPickup": "Um ativo em sua instalação está pronto para retirada."
  },
  "anchorLabels": {
    "appointmentDetailsHaveChanged": "Ver agendamento",
    "appointmentScheduled": "Ver agendamento",
    "appointmentConfirmed": "Ver agendamento",
    "appointmentRequested": "Ver agendamento",
    "missedAppointment": "Ver agendamento",
    "recurringAppointmentSeriesCreated": "Ver agendamento original",
    "truckArrivedAtFacility": "Ver agendamento",
    "appointmentIsInProgressAtFacility": "Ver agendamento",
    "appointmentRescheduled": "Ver agendamento",
    "appointmentCompleted": "Ver agendamento",
    "appointmentCancelled": "Ver agendamento",
    "appointmentTagged": "Ver agendamento",
    "assetReadyForPickup": "Ver agendamento"
  },
  "descriptions": {
    "appointmentTagged": "Use a configuração de Etiquetas de Agendamento para habilitá-las individualmente"
  },
  "contextLabels": {
    "assetReadyForPickup": {
      "schedulingAnchorLabel": "Agendar retirada",
      "idLabel": "Número de confirmação",
      "ownedByLabel": "Proprietário:",
      "pickupScheduledForLabel": "Retirada agendada para:",
      "noPickupScheduledLabel": "Nenhum agendamento de retirada",
      "storeLabel": "Loja",
      "openInGoogleMapsLabel": "Abrir no Google Maps",
      "appointmentDetailsLabel": "Detalhes do agendamento",
      "loadTypeLabel": "Tipo de carga",
      "warehouseInstructionsLabel": "Instruções do armazém",
      "amenitiesLabel": "Comodidades disponíveis",
      "ppeRequirementsLabel": "EPI e outros requisitos",
      "dockDoorLabel": "Porta de doca",
      "dockInstructionsLabel": "Instruções da doca",
      "carrierContactLabel": "Contato da transportadora"
    }
  }
}
